module.exports = __webpack_public_path__ + "img/inter23.97d2c258.jpg";